import type * as Style from '../../index.js'
import { Length, NullLength, pickFirst } from '../../values/index.js'

export const Props = (props: any = {}) => ({
  minWidth: [NullLength(props.minWidth), Length(props.minWidth)].reduce(pickFirst),
  maxWidth: [NullLength(props.maxWidth), Length(props.maxWidth)].reduce(pickFirst),
  minHeight: [NullLength(props.minHeight), Length(props.minHeight)].reduce(pickFirst),
  maxHeight: [NullLength(props.maxHeight), Length(props.maxHeight)].reduce(pickFirst)
})

export type Props = ReturnType<typeof Props>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const type = 'dimensions'
export const label = 'Dimensions'
export const property = 'dimensionIds'
export const category = 'aspect'
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) =>
  props.minWidth?.value || props.maxWidth?.value || props.minHeight?.value || props.maxHeight?.value
    ? props.minWidth?.value === props.maxWidth?.value && props.minHeight?.value === props.maxHeight?.value
      ? `${props.minWidth ? props.minWidth.value + props.minWidth.unit : 'Auto'} × ${
          props.minHeight ? props.minHeight.value + props.minHeight.unit : 'Auto'
        }`
      : 'Advanced'
    : 'Auto'
